__turbopack_context__.v({
  "black": "oseYsW_black",
  "black100": "oseYsW_black100",
  "black1000": "oseYsW_black1000",
  "black200": "oseYsW_black200",
  "black300": "oseYsW_black300",
  "black400": "oseYsW_black400",
  "black500": "oseYsW_black500",
  "black600": "oseYsW_black600",
  "black700": "oseYsW_black700",
  "black800": "oseYsW_black800",
  "black900": "oseYsW_black900",
  "blockquote": "oseYsW_blockquote",
  "blue200": "oseYsW_blue200",
  "blue400": "oseYsW_blue400",
  "blue600": "oseYsW_blue600",
  "blue800": "oseYsW_blue800",
  "blue900": "oseYsW_blue900",
  "button": "oseYsW_button",
  "button-group": "oseYsW_button-group",
  "cite": "oseYsW_cite",
  "container": "oseYsW_container",
  "ctaLink": "oseYsW_ctaLink",
  "custom": "oseYsW_custom",
  "custom-2": "oseYsW_custom-2",
  "defaultDesign": "oseYsW_defaultDesign",
  "divider": "oseYsW_divider",
  "double": "oseYsW_double",
  "green200": "oseYsW_green200",
  "green400": "oseYsW_green400",
  "green600": "oseYsW_green600",
  "green800": "oseYsW_green800",
  "green900": "oseYsW_green900",
  "heading": "oseYsW_heading",
  "isDark": "oseYsW_isDark",
  "logoContainer": "oseYsW_logoContainer",
  "logoImage": "oseYsW_logoImage",
  "pink200": "oseYsW_pink200",
  "pink400": "oseYsW_pink400",
  "pink600": "oseYsW_pink600",
  "pink800": "oseYsW_pink800",
  "purple200": "oseYsW_purple200",
  "purple400": "oseYsW_purple400",
  "purple600": "oseYsW_purple600",
  "purple800": "oseYsW_purple800",
  "purple900": "oseYsW_purple900",
  "quotePlain": "oseYsW_quotePlain",
  "quoteSection": "oseYsW_quoteSection",
  "red200": "oseYsW_red200",
  "red400": "oseYsW_red400",
  "red600": "oseYsW_red600",
  "red800": "oseYsW_red800",
  "red900": "oseYsW_red900",
  "sky1000": "oseYsW_sky1000",
  "type-sidelines": "oseYsW_type-sidelines",
  "type-sidelines-dotted": "oseYsW_type-sidelines-dotted",
  "useCaseLendingRed": "oseYsW_useCaseLendingRed",
  "white": "oseYsW_white",
  "withBackground": "oseYsW_withBackground",
  "withHeading": "oseYsW_withHeading",
  "yellow200": "oseYsW_yellow200",
  "yellow400": "oseYsW_yellow400",
  "yellow600": "oseYsW_yellow600",
  "yellow800": "oseYsW_yellow800",
  "yellow900": "oseYsW_yellow900",
});
